var isMobile = false;
 if( /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || document.documentElement.clientWidth <= 769 ) {
    isMobile = true;
}
$(document).ready(function() {
 	var urlParams = new URLSearchParams(window.location.search);
 	var emailFromURL = urlParams.get('email');
 	var origenValue = urlParams.get('origen');
 	if (origenValue) $("#origen").val(origenValue);
 	if (emailFromURL) $('#email').val(emailFromURL);
 	var formData = {
 		email: emailFromURL,
 		tipo: origenValue
 	};
 	$.ajax({
 		type: "POST",
 		url: "https://dev.socialpro.mx/ne_klaviyo/get_profile2.php",
 		data: formData,
 		dataType: 'json',
 		success: function(response) {
 			console.log(response);
 			if (response.accion == 'Nuevo') {
 				console.log('Nuevo')
 			} else {
               $('.txt-actualiza').css('display','block');
                if(response.properties.Género == 'Masculino'){
                  $('#masculino').prop('checked', true);
                } 
                if(response.properties.Género == 'Indistinto'){
                  $('#indistinto').prop('checked', true);
                }               
 				futTeams = response.properties.Fútbol;
                console.log(futTeams);
 				lmbTeams = response.properties.LMB;
 				mlbTeams = response.properties.MLB;
 				nbaTeams = response.properties.NBA;
 				nflTeams = response.properties.NFL;
 				dmTeams = response.properties.Deporte_motor;
 				var futTeams = futTeams.split(',');
 				var lmbTeams = lmbTeams.split(',');
 				var mlbTeams = mlbTeams.split(',');
 				var nbaTeams = nbaTeams.split(',');
 				var nflTeams = nflTeams.split(',');
 				var dmTeams = dmTeams.split(',');
                var zip = response.location.zip;
                var age = response.properties.Age;   
                $('#zip').val(zip);              
                $('#cumple').val(age);                          
 				$('.log').each(function() {
 					var valor = $(this).val();                    
 					if ($.inArray(valor, futTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 				$('.log').each(function() {
 					var valor = $(this).val();
 					if ($.inArray(valor, lmbTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 				$('.log').each(function() {
 					var valor = $(this).val();
 					if ($.inArray(valor, mlbTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 				$('.log').each(function() {
 					var valor = $(this).val();
 					if ($.inArray(valor, nbaTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 				$('.log').each(function() {
 					var valor = $(this).val();
 					if ($.inArray(valor, nflTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 				$('.log').each(function() {
 					var valor = $(this).val();
 					if ($.inArray(valor, dmTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 			}
 		},
 		error: function(error) {
 			alert("Error:", error);
 		}
 	});
 });
 document.addEventListener("DOMContentLoaded", function() {
 	var tabsData = [{
 		id: 2,
 		title: "NFL",
        img: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/slide-nfl.png?v=1725483824",   
        imgName: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/NFL_eaca2471-a80a-4206-8b02-f3f2c0011fad.png?v=1720800893",
 		content: [{
 			"id": "cowboys",
 			"nombre": "Cowboys",
 			"liga": "nfl[]"
 		}, {
 			"id": "sfers",
 			"nombre": "49ers",
 			"liga": "nfl[]"
 		}, {
 			"id": "raiders",
 			"nombre": "Raiders",
 			"liga": "nfl[]"
 		}, {
 			"id": "steelers",
 			"nombre": "Steelers",
 			"liga": "nfl[]"
 		}, {
 			"id": "patriotas",
 			"nombre": "Patriots",
 			"liga": "nfl[]"
 		}, {
 			"id": "broncos",
 			"nombre": "Broncos",
 			"liga": "nfl[]"
 		}, {
 			"id": "seahawks",
 			"nombre": "Seahawks",
 			"liga": "nfl[]"
 		}, {
 			"id": "packers",
 			"nombre": "Packers",
 			"liga": "nfl[]"
 		}, {
 			"id": "bears",
 			"nombre": "Bears",
 			"liga": "nfl[]"
 		}, {
 			"id": "bengals",
 			"nombre": "Bengals",
 			"liga": "nfl[]"
 		}, {
 			"id": "bills",
 			"nombre": "Bills",
 			"liga": "nfl[]"
 		}, {
 			"id": "browns",
 			"nombre": "Browns",
 			"liga": "nfl[]"
 		}, {
 			"id": "buccaneers",
 			"nombre": "Buccaneers",
 			"liga": "nfl[]"
 		}, {
 			"id": "cardinals",
 			"nombre": "Cardinals",
 			"liga": "nfl[]"
 		}, {
 			"id": "chargers",
 			"nombre": "Chargers",
 			"liga": "nfl[]"
 		}, {
 			"id": "chiefs",
 			"nombre": "Chiefs",
 			"liga": "nfl[]"
 		}, {
 			"id": "colts",
 			"nombre": "Colts",
 			"liga": "nfl[]"
 		}, {
 			"id": "dolphins",
 			"nombre": "Dolphins",
 			"liga": "nfl[]"
 		}, {
 			"id": "eagles",
 			"nombre": "Eagles",
 			"liga": "nfl[]"
 		}, {
 			"id": "falcons",
 			"nombre": "Falcons",
 			"liga": "nfl[]"
 		}, {
 			"id": "giants",
 			"nombre": "Giants",
 			"liga": "nfl[]"
 		}, {
 			"id": "jaguars",
 			"nombre": "Jaguars",
 			"liga": "nfl[]"
 		}, {
 			"id": "jets",
 			"nombre": "Jets",
 			"liga": "nfl[]"
 		}, {
 			"id": "lions",
 			"nombre": "Lions",
 			"liga": "nfl[]"
 		}, {
 			"id": "panthers",
 			"nombre": "Panthers",
 			"liga": "nfl[]"
 		}, {
 			"id": "rams",
 			"nombre": "Rams",
 			"liga": "nfl[]"
 		}, {
 			"id": "ravens",
 			"nombre": "Ravens",
 			"liga": "nfl[]"
 		}, {
 			"id": "redskins",
 			"nombre": "Redskins",
 			"liga": "nfl[]"
 		}, {
 			"id": "saints",
 			"nombre": "Saints",
 			"liga": "nfl[]"
 		}, {
 			"id": "texans",
 			"nombre": "Texans",
 			"liga": "nfl[]"
 		}, {
 			"id": "titans",
 			"nombre": "Titans",
 			"liga": "nfl[]"
 		}, {
 			"id": "vikings",
 			"nombre": "Vikings",
 			"liga": "nfl[]"
 		}]
 	}];
   
    Handlebars.registerHelper('ismoda', function (value) {
      return value === 'moda';
    });   
   
    var tabsTemplate = Handlebars.compile(document.getElementById("slide-template").innerHTML);
    document.getElementById("slide").innerHTML = tabsTemplate({
        tabs: tabsData
    }); 	

    var tabsTemplate = Handlebars.compile(document.getElementById("popup-template").innerHTML);
    document.getElementById("popups").innerHTML = tabsTemplate({
    	tabs: tabsData
    });    
 });


 (function($) {

  $('input').on('keypress', function() {
       $(this).removeClass('error');
  });

   $('#cumple').on('change', function() {
        $(this).removeClass('error');
    });


    $('input[name="contact[note][genero]"]').on('change', function() {
        if ($('input[name="contact[note][genero]"]:checked').length > 0) {
            $('#elgenero').removeClass('invalid');
        }
    });
   
  function isValidEmail(email) {
    // Expresión regular para validar el correo electrónico
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function isValidZip(zip) {
    // Expresión regular para validar el código postal (solo dígitos y longitud de 5)
    var zipRegex = /^\d{5}$/;
    return zipRegex.test(zip);
  }

   

  function isValidDate(date) {
    // Verificar si se ingresó una fecha válida (no está vacía)
    return !!date;
  }   
 	$(function() {

 $("#update").click(function() {
  $("input").removeClass('error');
   $("#error").html('');   
    var email = $('#email').val();
    var zip = $('#zip').val();
    var cumple = $('#cumple').val();
    var isValid = true;
   
    // Validación de correo electrónico
    if (!isValidEmail(email)) {
      $('#email').addClass('error');
      isValid = false;
    } else {
      $('#email').removeClass('error');
    }

    // Validación de código postal
    if (!isValidZip(zip)) {
      $('#zip').addClass('error');
      isValid = false;
    } else {
      $('#zip').removeClass('error');
    }

    // Validación de fecha de nacimiento
    if (!isValidDate(cumple)) {
      $('#cumple').addClass('error');
      isValid = false;
    } else {
      $('#cumple').removeClass('error');
    }

    if ($('input[name="contact[note][genero]"]:checked').length > 0) {
        
    } else {
        console.log('Ninguno está seleccionado.');
         isValid = false;      
        $('#elgenero').addClass('invalid');
    }
   

    // Si todos los campos son válidos
    if (isValid) {
      console.log(1);
      
           $('.message').html('<span>Estamos registrando sus datos...</span>')

        $('.message span').fadeOut(500, function(){
            $(this).fadeIn(500, function(){
                blink(); // Llamada recursiva para continuar el parpadeo
            });
        });      
 			var formData = {
 				email: $('#email').val(),
 				zip: $("#zip").val(),
                origen: $("#origen").val(),
 				cumple: $("input[name='contact[note][cumple]']").val(),
 				genero: $("input[name='contact[note][genero]']:checked").val(),
 				moda: $("input[name='moda']:checked").val(),              
 				futbol: $("input[name='futbol[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(','),
 				mlb: $("input[name='mlb[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(','),
 				lmb: $("input[name='lmb[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(','),
 				nfl: $("input[name='nfl[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(','),
 				nba: $("input[name='nba[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(','),
 				auto: $("input[name='auto[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(',')
 			};
 			console.log(formData);
 			$.ajax({
 				type: 'POST',
 				url: 'https://dev.socialpro.mx/ne_klaviyo/create_or_update_v2.php',
 				data: formData,
 				success: function(response) {                   				
                   window.location.href = "https://www.newera.mx/pages/gracias-por-suscribirte";
 				},
 				error: function(error) {
 					console.error('Error al enviar los datos', error);
 				}
 			});
      } else {
        $("#error").html('<p class="txt-error">Existen campos inválidos.</p>');
        }          
 	});
 	});
 	$('#fan-todo').change(function() {
 		var isChecked = $(this).prop('checked');
 		if (isChecked) {
 			$('input[type="checkbox"]').prop('checked', true);
 		} else {
 			$('input[type="checkbox"]').prop('checked', false);
 		}
 	});
 })(jQuery);

$(document).ready(function() { 
    var queryString = window.location.search;
    var url_equipo = new URLSearchParams(queryString);
    var equipo = url_equipo.get('origen');
  
    if (equipo == 'cruz_azul') {
      setTimeout(function() {
        
        $('.nav-link.active').removeClass('active');
        $('.tab-pane.fade.active.show').removeClass('active show');
        
        $('#tab5').addClass('active');
        $('#pane5').addClass('active show');

        $('#heading5 button').removeClass('collapsed');
        $('#collapse5').addClass('show');
        
        $('#cazul').prop('checked', true);
        $('#cazul').prop('disabled', true);      
        $('#cazul').next('label').addClass('checked');
        
      }, 500);
    }
});